export type MediaFrameFit = 'contain' | 'cover'

export function mediaFrameImageClass(fit: MediaFrameFit = 'contain'): string {
  return fit === 'cover'
    ? 'h-full w-full object-cover object-center'
    : 'h-full w-full object-contain object-center'
}

export function absoluteMediaFrameImageClass(fit: MediaFrameFit = 'contain'): string {
  return `absolute inset-0 ${mediaFrameImageClass(fit)}`
}
